import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1)
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "changeImage" }
const _hoisted_4 = { class: "changeImageWrapper" }
const _hoisted_5 = { class: "changeIcon" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { for: "firstName" }
const _hoisted_8 = { style: {"color":"red","font-size":"12px","position":"absolute","margin":"0","padding":"0"} }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { for: "lastName" }
const _hoisted_11 = { style: {"color":"red","font-size":"12px","position":"absolute","margin":"0","padding":"0"} }
const _hoisted_12 = { class: "gender" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_Female" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_Male" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "p-float-label error-label" }
const _hoisted_18 = { for: "birthDate" }
const _hoisted_19 = { class: "p-float-label error-label" }
const _hoisted_20 = { for: "phoneNumber" }
const _hoisted_21 = { class: "p-float-label error-label" }
const _hoisted_22 = { for: "email" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "col1" }
const _hoisted_25 = { class: "p-float-label" }
const _hoisted_26 = { for: "address" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "big" }
const _hoisted_29 = { class: "p-float-label" }
const _hoisted_30 = { for: "address" }
const _hoisted_31 = { class: "small" }
const _hoisted_32 = { class: "p-float-label" }
const _hoisted_33 = { for: "addressNumber" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = { class: "small" }
const _hoisted_36 = { class: "p-float-label" }
const _hoisted_37 = { for: "postNumber" }
const _hoisted_38 = { class: "big" }
const _hoisted_39 = { class: "p-float-label" }
const _hoisted_40 = { for: "city" }
const _hoisted_41 = { class: "p-float-label" }
const _hoisted_42 = { for: "municipality" }
const _hoisted_43 = { class: "p-float-label error-label" }
const _hoisted_44 = { for: "country" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "p-float-label error-label" }
const _hoisted_47 = { class: "flex align-items-center text-base" }
const _hoisted_48 = { class: "font-semibold" }
const _hoisted_49 = { class: "verificationStatus" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_alert icon" }, null, -1)
const _hoisted_51 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("edit_profile.title")), 1),
      _hoisted_1,
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "showImage",
                style: _normalizeStyle({ backgroundImage: `url(${_ctx.openedImage})` })
              }, null, 4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: "icon-warpit_icon_edit icon",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeImage())),
                  tabindex: "0",
                  onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.changeImage()), ["enter"]))
                }, null, 32)
              ])
            ]),
            _createElementVNode("input", {
              ref: "imageUpload",
              id: "imageUploadId",
              "hide-input": "",
              accept: "image/*",
              style: {"display":"none"},
              type: "file",
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args)))
            }, null, 544)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "firstName",
                type: "text",
                modelValue: _ctx.form.first_name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.first_name) = $event)),
                name: "firstName",
                maxlength: "35"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("edit_profile.first_name")), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errors.first_name), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_InputText, {
                id: "lastName",
                type: "text",
                modelValue: _ctx.form.last_name,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.last_name) = $event)),
                name: "lastName",
                maxlength: "35"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("edit_profile.last_name")), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.errors.last_name), 1)
            ])
          ]),
          _createElementVNode("li", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass({ selected: _ctx.form.gender_id === 0 }),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.gender_id = 0))
            }, _hoisted_14, 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass({ selected: _ctx.form.gender_id === 1 }),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.gender_id = 1))
            }, _hoisted_16, 2)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_17, [
              _createVNode(_component_Calendar, {
                id: "birthDate",
                name: "birthDate",
                modelValue: _ctx.birth_date,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.birth_date) = $event)),
                dateFormat: "dd.mm.yy"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("edit_profile.date_of_birth")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.birth_date), 1)
            ])
          ])
        ]),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("edit_profile.contact_info")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_19, [
              _createVNode(_component_InputText, {
                id: "phoneNumber",
                type: "text",
                modelValue: _ctx.form.phone_number,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.phone_number) = $event)),
                name: "phoneNumber",
                maxlength: "16"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("edit_profile.telephone_number")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.phone_number), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_21, [
              _createVNode(_component_InputText, {
                id: "email",
                type: "text",
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.email) = $event)),
                name: "email",
                maxlength: "320"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("edit_profile.email")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.email), 1)
            ])
          ])
        ]),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("edit_profile.address")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, [
                _createVNode(_component_GMapAutocomplete, {
                  class: _normalizeClass({
                  'p-inputtext p-component': !_ctx.addressSearch,
                  'p-inputtext p-component p-filled': _ctx.addressSearch,
                }),
                  onPlace_changed: _ctx.setAddress,
                  options: {
                  componentRestrictions: { country: 'si' },
                },
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addressSearch = $event.target.value)),
                  value: _ctx.addressSearch,
                  placeholder: "",
                  id: "address",
                  maxlength: "255"
                }, null, 8, ["class", "onPlace_changed", "value"]),
                _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("edit_profile.search")), 1)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, [
                _createVNode(_component_InputText, {
                  id: "address",
                  type: "text",
                  modelValue: _ctx.form.contact_info.address,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.contact_info.address) = $event)),
                  maxlength: "40",
                  name: "address",
                  onInput: _ctx.debounceLocalCommunity
                }, null, 8, ["modelValue", "onInput"]),
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("edit_profile.address")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, [
                _createVNode(_component_InputText, {
                  id: "addressNumber",
                  type: "text",
                  modelValue: _ctx.form.contact_info.house_number,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.contact_info.house_number) = $event)),
                  name: "addressNumber",
                  maxlength: "6",
                  onInput: _ctx.debounceLocalCommunity
                }, null, 8, ["modelValue", "onInput"]),
                _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("edit_profile.address_number")), 1)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", _hoisted_36, [
                _createVNode(_component_InputText, {
                  id: "postNumber",
                  type: "text",
                  modelValue: _ctx.form.contact_info.code,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.contact_info.code) = $event)),
                  name: "postNumber",
                  maxlength: "8",
                  onInput: _ctx.debounceLocalCommunity
                }, null, 8, ["modelValue", "onInput"]),
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("edit_profile.zip")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("span", _hoisted_39, [
                _createVNode(_component_InputText, {
                  id: "city",
                  type: "text",
                  modelValue: _ctx.form.contact_info.city,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.contact_info.city) = $event)),
                  name: "city",
                  maxlength: "30"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t("edit_profile.city")), 1)
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_41, [
              _createVNode(_component_InputText, {
                id: "municipality",
                type: "text",
                modelValue: _ctx.form.contact_info.municipality,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.contact_info.municipality) = $event)),
                name: "municipality",
                maxlength: "40"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("edit_profile.municipality")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_43, [
              _createVNode(_component_InputText, {
                id: "country",
                type: "text",
                modelValue: _ctx.form.contact_info.country,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.contact_info.country) = $event)),
                name: "country",
                maxlength: "40"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("edit_profile.country")), 1)
            ])
          ]),
          (_ctx.localCommunityEnabled)
            ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                _createElementVNode("span", _hoisted_46, [
                  _createVNode(_component_AutoComplete, {
                    modelValue: _ctx.localCommunityValue,
                    "onUpdate:modelValue": [
                      _cache[17] || (_cache[17] = ($event: any) => ((_ctx.localCommunityValue) = $event)),
                      _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectLocalCommunity($event)))
                    ],
                    suggestions: _ctx.localCommunities,
                    optionLabel: "title",
                    delay: 500,
                    loading: _ctx.isLoading,
                    disabled: _ctx.disabledLocalCommunity,
                    onComplete: _ctx.complete,
                    class: "w-full"
                  }, {
                    option: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_47, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent('IconMapPin'), { class: "mr-3" })),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_48, _toDisplayString(props.option.title), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "suggestions", "loading", "disabled", "onComplete"]),
                  _renderSlot(_ctx.$slots, "icon"),
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.local_community")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.errors.something_wrong), 1)
        ]),
        _createVNode(_component_Button, {
          "event-name": "userProfileSaveChangesButtonClick",
          "event-from": "/user/my-profile/edit",
          onClick: _withModifiers(_ctx.putUser, ["prevent"]),
          class: "defaultButton whiteBG margin-0",
          label: _ctx.$t(`edit_profile.save_changes`)
        }, null, 8, ["onClick", "label"])
      ]),
      _createVNode(_component_router_link, {
        to: { name: 'MyProfile' },
        class: "cancel"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showErrorDialog,
      "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showErrorDialog) = $event)),
      class: "successDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("error.invalid_image")), 1)
        ]),
        _createElementVNode("button", {
          class: "defaultButton",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showErrorDialog = false))
        }, _toDisplayString(_ctx.$t("dialog.close")), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}